import React, { useState, useEffect } from 'react';
import { AppContextProvider } from '../contexts';
import { ContextualizedApp } from '../app';
import { CircularProgress, Box } from "@mui/joy";
import { Backdrop } from "@mui/material";
import { useDataProvider } from '../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import * as Modules from '../../mtska-frontend-modules';
import '../../mtska-frontend-app-component/styles/components.scss';
import { useWindowDimensions } from './../hooks/useWindowDimensions'

const App = () => {

    const { innerHeight, innerWidth } = useWindowDimensions();

    const { i18n } = useTranslation();

    const { loadOne } = useDataProvider('auth/token');
    const { item: config, loadOne: loadConfig } = useDataProvider('configs/config');
    const { item: appconfig, loadOne: loadAppConfig } = useDataProvider('applications/app');
    const { item: moduleconfig, loadOne: loadModuleConfig } = useDataProvider('applications/module');

    const [appConfiguration, setAppConfiguration] = useState()
    const [user, setUser] = useState()
    const [userCapabilities, setUserCapabilities] = useState()
    const [existingModules, setExistingModules] = useState()

    const token = sessionStorage.getItem('token')

    useEffect(() => {
        loadAppConfig('670e3907863d1b0bfa9706b9').then((response) => {
            if (response && response.item && response.item.data) {
                response.item.data.modules.active = response.item.data.modules.active.map((module) => Modules[module]).filter((item) => { return item !== undefined })
                //console.info('Moduli attivi in App.js - se non trovi il tuo modulo al 99% non lo hai linkato in index.js di root di mtska-frontend-modules', response.item.data.modules.active);
                //console.info('Moduli dichiarati in index.js', Modules);
                setAppConfiguration(response.item.data);
            }
        });

        loadModuleConfig('0').then((response) => {
            if (response && response.item && response.item.data) {
                setExistingModules(response.item.data);
            }
        });

        if (token != null) {
            loadOne(sessionStorage.getItem('token')).then((response) => {
                response?.item?.data?.locale && i18n.changeLanguage(response.item.data.locale);
                setUser(response?.item?.data);
            });
            loadConfig(sessionStorage.getItem('token')).then((response) => {
                if (response && response.item && response.item.data) {
                    //console.info('APP::ho ricevuto la config', response.item.data.capabilities);
                    setUserCapabilities(response.item.data.capabilities);
                }
            });
        } else {
            setUserCapabilities([]);
        }
    }, [token])


    const concreteconfig = {
        appConfiguration,
        existingModules,
        innerHeight,
        innerWidth,
        user,
        setUser,
        userCapabilities,
        setUserCapabilities,
    }

    return (
        (appConfiguration && userCapabilities && existingModules) ? (
            <AppContextProvider concreteconfig={concreteconfig}>
                <ContextualizedApp />
            </AppContextProvider>
        ) : (
            <Backdrop open={true} sx={{ display: 'flex', flexDirection: 'column' }}>
                <CircularProgress />
                <Box sx={{ fontSize: '14px', margin: '30px 0', zIndex: '10000', color: 'white', display: 'inline-flex', borderRadius: '10px' }}>Loading Configuration</Box>
            </Backdrop>
        )
    )
}

export default App;